import { useLocation } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import Header from "./Header";
import Footer from "./Footer";

export const Layout = ({ children }) => {
    const location = useLocation();
    return (
        <div className="relative min-h-screen flex flex-col">
            {/* Global aurora background */}
            <div className="aurora fixed inset-0" aria-hidden="true" />

            <Header />

            <main
                className="relative z-10 flex-1 pt-[100px]"
                data-testid="page-main"
            >
                <AnimatePresence mode="wait">
                    <motion.div
                        key={location.pathname}
                        initial={{ opacity: 0, y: 10 }}
                        animate={{ opacity: 1, y: 0 }}
                        exit={{ opacity: 0, y: -6 }}
                        transition={{ duration: 0.35, ease: [0.2, 0.8, 0.2, 1] }}
                    >
                        {children}
                    </motion.div>
                </AnimatePresence>
            </main>

            <Footer />
        </div>
    );
};

export default Layout;
